import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync } from '../../core/ComponentSync.js';
import './TS_DragAndDrop.scss';
import { LL_V_L, LL_VH_C } from '../Layouts/index.js';
import { asArray } from '@nu-art/ts-common';
import { _className } from '../../utils/tools.js';
const DND_Styles = {
    Idle: 'idle',
    Dragging: 'dragging',
    Positive: 'positive',
    Negative: 'negative',
    PartialNegative: 'partial',
};
const timeoutSeconds = 2000;
const DefaultFilesRenderer = (props) => {
    return _jsxs(LL_V_L, { children: [props.acceptedFiles.map(file => _jsx("div", { style: { color: 'green' }, children: file.name })), props.rejectedFiles.map(file => _jsx("div", { style: { color: 'red' }, children: file.name }))] });
};
export class TS_DragAndDrop extends ComponentSync {
    static defaultProps = {
        renderer: DefaultFilesRenderer
    };
    inputRef = React.createRef();
    timers = [];
    deriveStateFromProps(nextProps) {
        return {
            dndState: 'Idle',
            acceptedFiles: [],
            rejectedFiles: [],
        };
    }
    componentWillUnmount() {
        this.timers.forEach(k => clearTimeout(k));
    }
    onSelect = (e) => {
        if (e.target.files) {
            this.updateFileArray(Object.values(e.target.files));
        }
    };
    static extractContent = (ev) => Object.values(ev.dataTransfer.files);
    extractPayload = (ev) => {
        const files = TS_DragAndDrop.extractContent(ev);
        if (files.length === 0) {
            this.setState({ dndState: 'Negative' });
            this.timers.push(setTimeout(() => this.setState({ dndState: 'Idle' }), timeoutSeconds));
            return;
        }
        return files;
    };
    static validateFilesBySuffix = (fileExt) => (files) => {
        const extensions = asArray(fileExt);
        return files.map((file) => {
            const accepted = extensions.some(ext => RegExp(`.${ext}$`, 'i').test(file.name));
            return { file, accepted };
        });
    };
    onDrop = (ev) => {
        ev.preventDefault();
        const files = this.extractPayload(ev);
        files && this.updateFileArray(files);
        TS_DragAndDrop.removeDragData(ev);
    };
    updateFileArray = (_files) => {
        const files = this.props.validate(_files);
        const acceptedFiles = files.filter(file => file.accepted).map(file => file.file);
        const rejectedFiles = files.filter(file => !file.accepted).map(file => file.file);
        let resultState = 'PartialNegative';
        if (acceptedFiles.length === 0)
            resultState = 'Negative'; // all files rejected
        else if (rejectedFiles.length === 0)
            resultState = 'Positive'; // all files accepted
        this.setState({ dndState: resultState, acceptedFiles, rejectedFiles }, () => this.props.onChange(acceptedFiles, rejectedFiles));
    };
    onDragEnter = (ev) => {
        ev.preventDefault();
        this.setState({ dndState: 'Dragging' });
    };
    onDragOver = (ev) => {
        ev.preventDefault();
        if (this.state.dndState !== 'Idle')
            return;
        const dndState = (ev.dataTransfer.items && ev.dataTransfer.items.length > 0) ? 'Dragging' : 'Negative';
        this.setState({ dndState });
    };
    onDragLeave = (ev) => {
        this.setState({ dndState: 'Idle' });
    };
    static removeDragData = (ev) => {
        if (ev.dataTransfer.items) {
            // Use DataTransferItemList interface to remove the drag data
            ev.dataTransfer.items.clear();
        }
        else {
            // Use DataTransfer interface to remove the drag data
            ev.dataTransfer.clearData();
        }
    };
    render() {
        const Renderer = this.props.renderer;
        return (_jsx(LL_VH_C, { className: _className('ts-drag-and-drop', this.props.className), id: this.props?.id, children: _jsxs("div", { className: `ts-drag-and-drop__content ts-drag-and-drop__${DND_Styles[this.state.dndState]}`, onDrop: this.onDrop, onDragEnter: this.onDragEnter, onDragOver: this.onDragOver, onDragLeave: this.onDragLeave, onClick: this.openFileChooser, children: [_jsx("input", { className: "ts-drag-and-drop__input", id: "fileInput", type: "file", ref: this.inputRef, hidden: true, multiple: true, onChange: this.onSelect }), _jsx(Renderer, { acceptedFiles: this.state.acceptedFiles, rejectedFiles: this.state.rejectedFiles })] }) }));
    }
    openFileChooser = () => {
        this.inputRef.current && this.inputRef.current.click();
    };
}
//# sourceMappingURL=TS_DragAndDrop.js.map